import { STATUS_PRIORITY } from '../config/kpi';
import type { KpiStatus, LineStatusRow } from '../types/bsc';
import { cleanText } from './text';
import { toNumber } from './numbers';

export interface StatusInput {
  value: unknown;
  Target?: unknown;
  Soglia_Minima?: unknown;
  Soglia_Eccellenza?: unknown;
  Trend_Desiderato?: unknown;
}

export function evaluateStatus(input: StatusInput): KpiStatus {
  const value = toNumber(input.value);
  if (value === null) {
    return 'Manca dato';
  }

  const target = toNumber(input.Target);
  const minimum = toNumber(input.Soglia_Minima);
  const excellence = toNumber(input.Soglia_Eccellenza);
  const trend = cleanText(input.Trend_Desiderato).toLocaleLowerCase('it-IT');

  const higherIsBetter = ['in crescita', 'crescita', 'aumento'].includes(trend);
  const lowerIsBetter = ['in diminuzione', 'diminuzione', 'riduzione'].includes(trend);
  const stableIsBetter = ['stabile', 'stabilità', 'stabilita'].includes(trend);

  if (stableIsBetter) {
    if (target === null) {
      return 'Da definire';
    }

    const delta = Math.abs(value - target);
    if (excellence !== null && delta <= Math.abs(excellence)) {
      return 'Eccellente';
    }
    if (minimum !== null && delta <= Math.abs(minimum)) {
      return 'Fuori target';
    }
    if (minimum !== null) {
      return 'Critico';
    }
    return 'Da definire';
  }

  if (excellence !== null) {
    if ((higherIsBetter && value >= excellence) || (lowerIsBetter && value <= excellence)) {
      return 'Eccellente';
    }
  }

  if (target !== null) {
    if ((higherIsBetter && value >= target) || (lowerIsBetter && value <= target)) {
      return 'In target';
    }
  }

  if (minimum !== null) {
    if ((higherIsBetter && value >= minimum) || (lowerIsBetter && value <= minimum)) {
      return 'Fuori target';
    }
    return 'Critico';
  }

  if (target !== null) {
    return 'No target';
  }

  return 'Da definire';
}

export function getOverallStatus(statuses: KpiStatus[]): KpiStatus | null {
  if (statuses.length === 0) {
    return null;
  }

  return statuses.reduce((worst, current) =>
    STATUS_PRIORITY[current] > STATUS_PRIORITY[worst] ? current : worst,
  );
}

export function countLineStatuses(
  rows: LineStatusRow[],
): Partial<Record<KpiStatus, number>> {
  return rows.reduce<Partial<Record<KpiStatus, number>>>((counts, row) => {
    counts[row.line_status] = (counts[row.line_status] ?? 0) + 1;
    return counts;
  }, {});
}
